/**
 * FactoryManager.ts
 */
export class FactoryManager {
    constructor() {
        if (FactoryManager.instance) {
            throw new Error("FactoryManager Singleton Already Initialised");
        }
        FactoryManager.instance = this;
    }
    setFactory(value) {
        this.factory = value;
    }
    getFactory() {
        return this.factory;
    }
    static getInstance() {
        if (FactoryManager.instance === null) {
            FactoryManager.instance = new FactoryManager();
        }
        return FactoryManager.instance;
    }
}
FactoryManager.instance = null;
//# sourceMappingURL=FactoryManager.js.map